<template>
  <div class="quote-edit-row pdf-export-block">
    <div class="left">
      <AppQuoteEditItem
        v-if="leftEdit.created_at"
        :item="leftEdit"
        data-test="left edit"
        tag="div"
      />
    </div>
    <div class="right">
      <AppQuoteEditItem
        v-if="rightEdit.created_at"
        :item="rightEdit"
        data-test="right edit"
        tag="div"
      />
    </div>
  </div>
</template>

<script>
/**
 * Quote Edits Export Row
 *
 * @vuedoc
 * @exports components/TfPdfExport/QuoteEdits/Row
 * @category Components
 */
  export default {
    name: 'QuoteEditsExportRow',
    props: {
      leftEdit: {
        type: Object,
        default: () => ({}),
      },
      rightEdit: {
        type: Object,
        default: () => ({}),
      },
    },
  };
</script>

<style lang="scss" scoped>
  .quote-edit-item::v-deep {
    padding: 0;
    text-align: left;
    border: 0;

    p,
    .time {
      font-size: 12px;
      line-height: 16px;
      color: var(--tf-black);
    }
  }

  .quote-edit-row {
    display: flex;
    width: 504px;

    div {
      flex: 1 0;
      width: 220px;
      padding-right: 32px;
      padding-bottom: 20px;
    }

    div:nth-child(2) {
      padding-left: 32px;
      padding-right: 0;
    }
  }
</style>
